<div [innerHTML]="text" *ngIf="text"></div>
